import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";


import css from './ProgramTerms.module.css';

const ProgramTerms = props => {
  const { rootClassName, className, intl } = props;
  const classes = classNames(rootClassName || css.root, className);

  const text = intl.formatMessage({
    id: "ProgramTermsPage.programTerms"
  });

  return (
    <div className={classes}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {text}
      </ReactMarkdown>
    </div>
  );
};

ProgramTerms.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

ProgramTerms.propTypes = {
  rootClassName: string,
  className: string,
};

export default ProgramTerms;
